import type { ContextWeight } from '@ace-tracker/shared';

export function ContextWeightChart({ contextWeight }: { contextWeight: ContextWeight }) {
  const max = Math.max(contextWeight.inputTokens, contextWeight.outputTokens, 1);

  return (
    <div className="flex h-full flex-col justify-center">
      <div className="grid gap-5">
        <Row label="Input (context sent)" value={contextWeight.inputTokens} max={max} colorClassName="bg-primary-blue" />
        <Row label="Output (generated)" value={contextWeight.outputTokens} max={max} colorClassName="bg-success" />
      </div>
      {contextWeight.ratio > 0 && (
        <p className="mt-5 border-t border-border pt-3 text-xs text-text-muted">
          <span className="font-semibold text-text-default">{contextWeight.ratio}:1</span> input-to-output ratio — prompt
          hygiene and file scoping cut cost faster than reducing usage.
        </p>
      )}
    </div>
  );
}

function Row({ label, value, max, colorClassName }: { label: string; value: number; max: number; colorClassName: string }) {
  const widthPercent = Math.max((value / max) * 100, value > 0 ? 0.6 : 0);
  const fitsInside = widthPercent > 22;
  return (
    <div>
      <p className="mb-1.5 text-[11px] uppercase tracking-wide text-text-faint">{label}</p>
      <div className="relative h-9">
        <div className={`absolute inset-y-0 left-0 rounded ${colorClassName}`} style={{ width: `${widthPercent}%` }} />
        <span
          className={`absolute inset-y-0 flex items-center whitespace-nowrap text-sm font-bold tabular-nums ${
            fitsInside ? 'left-0 px-3 text-text-inverse' : 'text-text-default'
          }`}
          style={fitsInside ? undefined : { left: `calc(${widthPercent}% + 10px)` }}
        >
          {value.toLocaleString()}
        </span>
      </div>
    </div>
  );
}
